<template>
  <div class="date-form">
    <el-row>
      <div class="el-col year-input">
        <el-form-item prop="year">
          <el-select v-model="data.year"
                :placeholder="yearText"
                class="input-datetime" name="year"
                @change="changeDate">
            <el-option v-for="year in years" :key="year" :label="year" :value="year"></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="el-col">
        <el-form-item prop="month">
          <el-select v-model="data.month"
                :placeholder="$t('staff.form.input_placeholder.month')"
                class="input-datetime" name="month"
                :no-data-text="$t('no_data')"
                @change="changeDate"
                >
            <el-option v-for="(month, index) in months" :key="index" :label="month" :value="month"></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="el-col day-input" v-if="showDayInput">
        <el-form-item prop="day">
          <el-select v-model="data.day"
                :placeholder="$t('staff.form.input_placeholder.day')" class="input-datetime"
                name="day" :no-data-text="$t('no_data')"
                @change="changeDate">
            <el-option v-for="(day, index) in days" :key="index" :label="day" :value="day"></el-option>
          </el-select>
        </el-form-item>
      </div>
    </el-row>
  </div>
</template>

<script>
  import { YEARS, MONTHS, GENDERS } from '../constants'

  export default {
    props: {
      date: { type: Object, required: false, default: { day: '', month: '', year: '' } },
      showDayInput: { type: Boolean, required: false, default: true },
      listYear: { type: Array, required: false, default: [] },
      yearPlaceHolder: { type: String, required: false, default: '' }
    },
    data() {
      return {
        years: YEARS,
        data: this.date,
        yearText: this.$t('staff.form.input_placeholder.year')
      }
    },

    methods: {
      changeDate() {
        if (this.data.day > this.days.length) {
          this.data.day = '';
        }

        this.$emit('changeDate', this.data)
      }
    },

    computed: {
      quantityDay() {
        if (!this.form.year || !this.form.month) {
          return 0;
        }

        return new Date(this.form.year, this.form.month, 0).getDate();
      },

      formatDay() {
        if (!this.date.year || !this.date.month || !this.date.day) {
          return '';
        }

        return this.date.year + '/' + this.date.month + '/' + this.date.day;
      },

      days() {
        if (!this.data.year || !this.data.month) {
          return [];
        }
        const quantityDay =  new Date(this.data.year, this.data.month, 0).getDate();

        return [...Array(quantityDay).keys()].map(i => this.$dayjs(new Date(0, 0, i + 1)).format("DD"));
      },

      months() {
        if (!this.data.year) {
          return [];
        }

        return MONTHS;
      }
    },

    created() {
      if (this.listYear.length > 0) {
        this.years = this.listYear;
      }
      if (this.yearPlaceHolder) {
        this.yearText = this.yearPlaceHolder;
      }
    }
  }
</script>
<style lang="scss">
  .date-form {
   .el-form-item__content {
      margin-top: 0 !important;
    }
    .day-input {
      .input-datetime {
        margin-right: 0;
      }
    }
  }
</style>
